import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  stop(event: Event) {
    event.stopPropagation()
  }
}
